import { render } from "./Divider.vue?vue&type=template&id=15f084db&scoped=true&ts=true"
import script from "./Divider.vue?vue&type=script&lang=ts"
export * from "./Divider.vue?vue&type=script&lang=ts"

import "./divider.scss?vue&type=style&index=0&id=15f084db&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f084db"]])

export default __exports__